// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppstoreOutlinedSvg from "@fishx/icons-svg/es/asn/AppstoreOutlined";
import FishxIcon from '../components/FishxIcon';

var AppstoreOutlined = function AppstoreOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreOutlinedSvg
  }));
};

AppstoreOutlined.displayName = 'AppstoreOutlined';
export default React.forwardRef(AppstoreOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AppstoreOutlined.js
// module id = 2012
// module chunks = 0